import React, { Component } from 'react'
import AlertTwo from '../etc/AlertTwo'
import FlashCardAdd from './FlashcardAdd'
import Reader from '../../controller/Reader'
import Updater from '../../controller/Updater'


export default class FlashCardContainer extends Component {

	constructor() {
		super();
		this.state = {
            cards: [],
            cardNum: 0,
            onlyUnmem: false,
            isAlert: false,
            editOpen: false
		}
	}

	componentDidMount() {

        this.getFx()

    }
    

    getFx = () => {

        let condition = {
            url : '/api/fcard/list'
        }

        Reader(condition, res => {

            if(res.data !== null) {
    
                this.setState({
                    cards : res.data
                })
            }
        })
    }


    editFx = () => {

        if(!this.props.isLogin) {

            this.setState({ isAlert : true,
            editOpen : false})
        
        } else {

            this.setState({
                isAlert : false,
                editOpen : true
            })
        }
    }

    closeFx = () => {

        this.setState({
            isAlert : false,
            editOpen : false
        })

    }


    listunmemFx = (e) => {

        if (!this.state.onlyUnmem) {
        
            this.setState({ onlyUnmem : true })
        
        } else {

            this.setState({ onlyUnmem : false })

        }
    }


	render() {

		let viewFx = () => {

			this.refs.checkHidden.style.visibility = 'visible'
        
        }


        let filterVal = (item) => {

            if (this.state.onlyUnmem) {
                return item.isMem === false &&
                    item.catg === this.props.catg

            } else {
                return item.catg === this.props.catg
            }
        }

        let filtIt = this.state.cards.filter(filterVal)

		let cardsSet = filtIt.map( (card, index) => {

			return (

				<React.Fragment>
					
                    <div className='FcardIsmem '>
                    
                        <i className='material-icons' onClick={() => {memitFx(card._id, card.isMem)}} style={{color: card.isMem ? '#AE9A8A' : '#22252C' }}>spellcheck</i>
                    
                    </div>

                    <div className='FcardWord'>
                    
                        <span> {card.word} </span>
                    
                        <h3>[{card.pronaun}]</h3>
                    
                    </div>

                    <div ref='checkHidden' style={{visibility:'hidden'}}>

                        <h2 style={{marginTop:'1.5rem'}}> {card.meaning} </h2>
                    
                    </div>
                    	
				</React.Fragment>
			)
		})


        let nextFx = () => {
        	   
			const cardLength = filtIt.length			
			this.setState(
				{cardNum: Math.floor((Math.random() * cardLength) + 0)}
            )
            this.refs.checkHidden.style.visibility = 'hidden'
            	
        }


        let memitFx = (id, mem) => {

            if(!this.props.isLogin) {

                this.setState({ isAlert : true })

                return
            }


            let condition = {
                url : '/api/fcard/update/' + id,
                data : {
                    isMem: !mem ? true : false
                }
            }

            Updater(condition, res => {

                console.log(res.message)

                this.nextFx()

            })

        }


		return (
			
            <React.Fragment>
                
                <div className='FcardContainer'>
                
                    {cardsSet[this.state.cardNum]} 

                    <div className='FcardMenu'>
                        <i className='material-icons' onClick={nextFx}>play_arrow</i>
                        <i className='material-icons' onClick={viewFx}>visibility</i>
                        <i className='material-icons' onClick={this.listunmemFx} style={{ opacity : this.state.onlyUnmem ? 0.5 : 1 }}>playlist_add_check</i>
                        <i className='material-icons' onClick={this.editFx}>add</i>
                    </div>

                </div>

                { this.state.isAlert ? <AlertTwo alert='Access Denied' closeMe = { this.closeFx } /> : null }

                {this.state.editOpen === true ? <FlashCardAdd closeMe={this.closeFx} /> : null}

            </React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/flashcard/FlashcardContainer.js